export enum IdVerificationEvents {
  VERIFICATION_UPDATED = 'verification:updated',
  QUEUE_INITIAL = 'queue:initial',
  QUEUE_ITEM_ADDED = 'queue:itemAdded',
  QUEUE_ITEM_REMOVED = 'queue:itemRemoved',
  QUEUE_STALE_ITEMS = 'queue:staleItems',
}